import React from 'react'
import PageLayout from '../pagelayout';
import StoreLogin from './storeLogin';

const StoreHome = ({history}) => (
    <PageLayout bgStore fullWidth>
        <div className="store-login-layout">
            <StoreLogin history={history} />
        </div>
    </PageLayout>
)

export default StoreHome
